import { useTranslation } from 'react-i18next';

function Icon({ d, color, size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d={d} stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default function Reasons() {
  const { t } = useTranslation();
  const benefits = [
    {
      iconBg: '#FBE3D2',
      iconColor: '#C2410C',
      iconPath: 'M12 7 V12 L15.5 14 M21 12 A9 9 0 1 1 3 12 A9 9 0 0 1 21 12 Z',
      title: t('reason1Title'),
      body: t('reason1Text'),
    },
    {
      iconBg: '#E4EFE0',
      iconColor: '#4A7A54',
      iconPath: 'M12 3 V21 M7 7.5 C7 5.8 9 4.8 12 4.8 C15 4.8 17 5.8 17 7.5 C17 9.5 15 10.2 12 10.6 C9 11 7 12 7 14 C7 16.2 9.5 17.2 12 17.2 C14.5 17.2 17 16.2 17 14.5',
      title: t('reason2Title'),
      body: t('reason2Text'),
    },
    {
      iconBg: '#E7E4F4',
      iconColor: '#5E568F',
      iconPath: 'M9 3 H15 L14 10 H19 L10 21 L11.5 13 H7 Z',
      title: t('reason3Title'),
      body: t('reason3Text'),
    },
  ]

  return (
    <section id="reasons" className="mx-auto max-w-[1280px] px-6 py-24 sm:py-28 lg:px-16">
      <div className="flex flex-col items-center gap-[72px] lg:flex-row">
        {/* Left: benefit cards */}
        <div className="flex min-w-0 flex-1 flex-col gap-5">
          <h2 className="text-4xl font-bold leading-tight tracking-[-1px] text-ink">{t("reasonsTitle")}</h2>
          <div className="mt-2 flex flex-col gap-3.5">
            {benefits.map((b) => (
              <div key={b.title} className="flex gap-[18px] rounded-3xl bg-surface p-6 shadow-card">
                <div
                  className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl"
                  style={{ background: b.iconBg }}
                >
                  <Icon d={b.iconPath} color={b.iconColor} size={22} />
                </div>
                <div className="flex flex-col gap-1.5">
                  <h3 className="text-base font-bold text-ink">{b.title}</h3>
                  <p className="text-sm leading-relaxed text-muted">{b.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: stat cards */}
        <div className="flex w-full min-w-0 flex-1 flex-col items-center gap-6">
          <div className="grid w-full max-w-[440px] grid-cols-2 gap-[18px]">
            <div className="flex flex-col gap-1.5 rounded-4xl bg-ink px-7 py-8">
              <span className="text-[42px] font-bold leading-none tracking-[-1px] text-[#FF9900]">{t("benefitStatHandValue")}</span>
              <span className="text-sm font-medium text-[#C9B8A6]">{t("benefitStatHandLabel")}</span>
            </div>
            <div className="flex flex-col gap-1.5 rounded-4xl bg-surface px-7 py-8 shadow-card">
              <span className="text-[42px] font-bold leading-none tracking-[-1px] text-ink">{t("benefitStatGenValue")}</span>
              <span className="text-sm font-medium text-muted">{t("benefitStatGenLabel")}</span>
            </div>
            <div className="col-span-2 flex items-center justify-between rounded-4xl bg-surface px-7 py-8 shadow-card">
              <div className="flex flex-col gap-1.5">
                <span className="text-[42px] font-bold leading-none tracking-[-1px] text-ink">{t("benefitStatSavedValue")}</span>
                <span className="text-sm font-medium text-muted">{t("benefitStatSavedLabel")}</span>
              </div>
              <Icon
                size={52}
                color="#7BAE85"
                d="M12 3 V21 M7 7.5 C7 5.8 9 4.8 12 4.8 C15 4.8 17 5.8 17 7.5 C17 9.5 15 10.2 12 10.6 C9 11 7 12 7 14 C7 16.2 9.5 17.2 12 17.2 C14.5 17.2 17 16.2 17 14.5"
              />
            </div>
          </div>
          <p className="max-w-[380px] text-center text-[13px] text-faint">{t("benefitStatFootnote")}</p>
        </div>
      </div>
    </section>
  )
}
